export function collectMetadata() {
    return {
        url: window.location.href,
        viewport: {
            width: window.innerWidth,
            height: window.innerHeight,
        },
        userAgent: navigator.userAgent,
        capturedAt: new Date().toISOString(),
    };
}
//# sourceMappingURL=metadata.js.map